<template>
  <div id="app">
    <a-config-provider :locale="zh_CN">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";

export default {
  name: "App",
  data() {
    return {
      zh_CN,
    };
  },
};
</script>

<style>
html {
  height: 100%;
}

* {
  box-sizing: border-box;
}

body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
}
.panel .ant-table {
  min-height: 220px !important;
}

.mobile-table-wrap,
.ant-table-wrapper {
  max-width: 100%;
}

.mobile-full {
  max-width: 100%;
}

@media (max-width: 768px) {
  body {
    min-width: 0;
    overflow-x: hidden;
  }

  .ant-card {
    border-radius: 6px !important;
  }

  .ant-card-head {
    min-height: 44px !important;
    padding: 0 12px !important;
  }

  .ant-card-head-title {
    padding: 11px 0 !important;
  }

  .ant-card-body {
    padding: 12px !important;
  }

  .ant-table-wrapper,
  .mobile-table-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .ant-table {
    min-width: 720px;
  }

  .ant-table-small > .ant-table-content > .ant-table-body {
    margin: 0 !important;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    white-space: nowrap;
    padding: 8px !important;
  }

  .ant-btn-group {
    display: inline-flex !important;
    flex-wrap: wrap;
    gap: 4px;
  }

  .ant-btn-group .ant-btn {
    border-radius: 4px !important;
    margin-left: 0 !important;
  }

  .ant-pagination {
    white-space: normal;
  }

  .ant-pagination-options {
    display: none !important;
  }

  .ant-modal {
    max-width: calc(100vw - 16px) !important;
    margin: 8px auto !important;
  }

  .ant-modal-body {
    padding: 12px !important;
  }

  .ant-modal-footer {
    padding: 8px 12px !important;
  }

  .ant-row > .ant-col,
  .ant-row > [class^="ant-col-"],
  .ant-row > [class*=" ant-col-"] {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
  }

  .mobile-stack {
    display: flex !important;
    flex-direction: column !important;
    gap: 10px;
  }

  .mobile-full,
  .mobile-stack > * {
    width: 100% !important;
    max-width: 100% !important;
    margin-left: 0 !important;
  }

  .mobile-form-row {
    display: block !important;
    width: 100% !important;
    margin-left: 0 !important;
  }

  .mobile-form-row + .mobile-form-row {
    margin-top: 12px !important;
  }

  div[style*="width: 300px"],
  div[style*="width: 340px"],
  div[style*="width: 256px"],
  .ant-col[style*="width: 300px"],
  .ant-col[style*="width: 340px"],
  .ant-col[style*="max-width: 256px"] {
    width: 100% !important;
    max-width: 100% !important;
  }

  div[style*="margin-left: 30px"],
  div[style*="margin-left: 32px"],
  .ant-col[style*="margin-left"] {
    margin-left: 0 !important;
  }

  div[style*="display: flex;flex-direction: row;width: 100%"],
  div[style*="display: flex; flex-direction: row;width: 100%"],
  div[style*="width: 100%;display: flex"],
  div[style*="display: flex;margin-top"] {
    flex-direction: column !important;
    gap: 10px;
  }

  div[style*="width: 48%"],
  div[style*="width: 60%"],
  div[style*="width: 36%"] {
    width: 100% !important;
    margin-left: 0 !important;
  }

  #YearChargeEcharts,
  #circle_echart,
  #Week_Track_echart,
  #ThreeEcharts,
  #xiaoshou_echarts {
    width: 100% !important;
    height: 320px !important;
    margin-left: 0 !important;
  }

  #container,
  #panel {
    height: 360px !important;
  }

  #panel {
    position: static !important;
    width: 100% !important;
    margin-top: 8px;
  }
}
</style>
